import { makeStyles } from '@fluentui/react-components';
import { WelcomeSection } from '@layouts/WelcomeSection';

const useDemoStyles = makeStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    padding: '1.5rem 0',
    boxSizing: 'border-box',
  },
});

export const WelcomeCardDemo = () => {
  const styles = useDemoStyles();

  const handleStartNewRequest = () => {
    // eslint-disable-next-line no-console
    console.log('Start new request clicked');
  };

  return (
    <div className={styles.page}>
      <WelcomeSection onStartNewRequest={handleStartNewRequest} />
    </div>
  );
};

WelcomeCardDemo.displayName = 'WelcomeCardDemo';
